<template>
    <div class="row dashboard">
        <FullPageLoader :isLoading="loading"/>

        <div class="column">
            <h1 class="title">
                {{ greeting }}{{ user.name ? ', ' + user.name : '' }}.
            </h1>

            <h3><strong>Dashboard</strong> / <span class="font-light">{{ _.isNull(dateRange) ? 'Resultaten afgelopen maand' : 'Resultaten in periode' }}</span></h3>

            <div class="row">
                <div class="column large-7">
                    <div class="card">
                        <!-- <h4>Facturen en betalingen</h4> -->
                        <div class="row dashblock" style="margin-bottom:10px">
                            <div class="column medium-4 text-center dblock">
                                <h4>Gefactureerd</h4>
                                <h5 class="marginbottom0" :class="{ 'text-primary': paymentsAggTotals.invoiced > 0 }">
                                    €&nbsp;<animated-number :value="paymentsAggTotals.invoiced || 0" :format-function="(val) => number_format(val, 2)" :hide-sensitive-data="hideSensitiveData" :duration="1200" />
                                </h5>
                            </div>
                            <div class="column medium-4 text-center dblock">
                                <h4>Betaald</h4>
                                <h5 class="marginbottom0" :class="{ 'text-success': paymentsAggTotals.paid > 0 }">
                                    €&nbsp;<animated-number :value="paymentsAggTotals.paid || 0" :format-function="(val) => number_format(val, 2)" :hide-sensitive-data="hideSensitiveData" :duration="1200" />
                                </h5>
                            </div>
                            <div class="column medium-4 text-center dblock">
                                <h4>Gecrediteerd</h4>
                                <h5 class="marginbottom0" :class="{ 'text-danger': paymentsAggTotals.credited > 0 }">
                                    {{ paymentsAggTotals.credited ? '-€ ' : '€ ' }}<animated-number :value="paymentsAggTotals.credited || 0" :format-function="(val) => number_format(val, 2)" :hide-sensitive-data="hideSensitiveData" :duration="1200" />
                                </h5>
                            </div>
                        </div>

                        <b-tabs position="is-right" class="block" v-model="paymentTab" @input="paymentTabChanged">
                            <b-tab-item label="Dagelijks">
                                <apexchart ref="paymentsChart" type="area" :key="paymentsAggKey" width="100%" :options="paymentsAgg.chartOptions" :series="paymentsAgg.series"></apexchart>
                            </b-tab-item>
                            <b-tab-item label="Opbouwend">
                                <apexchart ref="paymentsChart" type="area" :key="paymentsAggKey" width="100%" :options="paymentsAgg.chartOptions" :series="paymentsAgg.series"></apexchart>
                            </b-tab-item>
                        </b-tabs>
                    </div>
                </div>
                <div class="column large-5">
                    <div class="card">
                        <div class="row" style="margin-bottom: 1rem;">
                            <div class="column">
                                <h4>{{ chartView === 'escalations' ? 'Escalaties open en betaald' : 'Box verhuur' }}</h4>
                            </div>
                            <div class="column text-right" v-if="hasEscalationData">
                                <div class="field">
                                    <div class="control">
                                        <label class="radio">
                                            <input type="radio" v-model="chartView" value="boxes" name="chartToggle">
                                            Boxen
                                        </label>
                                        <label class="radio">
                                            <input type="radio" v-model="chartView" value="escalations" name="chartToggle">
                                            Escalaties
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="chartView === 'escalations' && hasEscalationData">
                            <div class="row">
                                <div class="column">
                                    <apexchart v-if="escalations.series && escalations.series.length === 2" type="donut" :key="escalationsKey" width="100%" height="280" :options="escalations.chartOptions" :series="escalations.series"></apexchart>
                                    <div v-else class="chart-placeholder">
                                        <div class="placeholder-text">Geen escalatie data beschikbaar</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="column">
                                    <small><strong>Open:</strong> € {{ hideSensitiveData ? '****' : number_format(escalationsTotals.open || 0, 2) }} | <strong>Betaald:</strong> € {{ hideSensitiveData ? '****' : number_format(escalationsTotals.paid || 0, 2) }}</small>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="row">
                                <div class="column">
                                    <apexchart v-if="boxUtilization.series && boxUtilization.series.length === 2" ref="boxUtilizationChart" type="donut" :key="boxUtilizationKey" width="100%" height="280" :options="boxUtilization.chartOptions" :series="boxUtilization.series"></apexchart>
                                    <div v-else class="chart-placeholder">
                                        <div class="placeholder-text">Geen box data beschikbaar</div>
                        </div>
                    </div>
                            </div>
                            <div class="row">
                                <div class="column">
                                    <small><strong>Verhuurd:</strong> {{ hideSensitiveData ? '****' : formatNumber(kpis.boxes_rented_count || 0) }} van {{ hideSensitiveData ? '****' : formatNumber(kpis.total_boxes_count || 0) }} ({{ boxUtilizationPercentage }}%)</small>
                                </div>
                                </div>
                            </div>
                    </div>



                    <div class="card kpi-card">
                        <h6>Nieuwe contracten</h6>
                        <h2 class="margin0">
                                                        <strong><animated-number :value="kpis.contracts_started || 0" :hide-sensitive-data="hideSensitiveData" /></strong>
                            <small>van totaal <animated-number :value="kpis.contracts_total_active || 0" :hide-sensitive-data="hideSensitiveData" /> ({{ shareContracts }}%)</small>
                        </h2>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="column large-4 medium-6">
                    <div class="card kpi-card">
                         <h6>Verzonden e-mails</h6>
                         <h2 class="margin0">
                             <strong><animated-number :value="kpis.sent_emails || 0" :hide-sensitive-data="hideSensitiveData" /></strong>
                             <small>van totaal <animated-number :value="kpis.sent_emails_total || 0" :hide-sensitive-data="hideSensitiveData" /></small>
                         </h2>
                    </div>
                </div>
                <div class="column large-4 medium-6 end">
                    <div class="card kpi-card">
                        <h6>{{ !_.isNull(dateRange) ? 'Nieuwe klanten in periode' : 'Nieuwe klanten (afgelopen 30 dagen)' }}</h6>
                        <h2 class="margin0">
                                                        <strong><animated-number :value="kpis.new_customers || 0" :hide-sensitive-data="hideSensitiveData" /></strong>
                            <small>van totaal <animated-number :value="kpis.total_customers || 0" :hide-sensitive-data="hideSensitiveData" /> ({{ shareCustomers }}%)</small>
                        </h2>
                    </div>
                </div>
                <div class="column large-4 medium-6">
                    <div class="card kpi-card">
                        <h6>Online verhuur aanvragen</h6>
                        <h2 class="margin0">
                                                        <strong><animated-number :value="kpis.online_rentals || 0" :hide-sensitive-data="hideSensitiveData" /></strong>
                            <small>van totaal <animated-number :value="kpis.online_rentals_total || 0" :hide-sensitive-data="hideSensitiveData" /> ({{ shareOnline }}%)</small>
                        </h2>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="column large-4 medium-6">
                    <div class="card kpi-card">
                        <h6>Facturen verzonden</h6>
                        <h2 class="margin0">
                                                        <strong><animated-number :value="kpis.invoices_sent_count || 0" :hide-sensitive-data="hideSensitiveData" /></strong>
                            <small>van totaal <animated-number :value="kpis.invoices_sent_total || 0" :hide-sensitive-data="hideSensitiveData" /></small>
                        </h2>
                </div>
            </div>
                <div class="column large-4 medium-6">
                    <div class="card kpi-card">
                        <h6>Betaalbevestigingen verzonden</h6>
                        <h2 class="margin0">
                                                        <strong><animated-number :value="kpis.invoices_paid_send_count || 0" :hide-sensitive-data="hideSensitiveData" /></strong>
                            <small>van totaal <animated-number :value="kpis.invoices_paid_send_total || 0" :hide-sensitive-data="hideSensitiveData" /></small>
                        </h2>
                        </div>
                        </div>
                <div class="column large-4 medium-6">
                    <div class="card kpi-card">
                        <h6>Boxen verhuurd / <span class="font-light">Gemiddelde prijs</span></h6>
                        <h2 class="margin0">
                                                        <strong><animated-number :value="kpis.boxes_rented_count || 0" :hide-sensitive-data="hideSensitiveData" /></strong>
                            <span class="font-light">/ € <animated-number :value="kpis.avg_box_price || 0" :format-function="(val) => number_format(val, 2)" :hide-sensitive-data="hideSensitiveData" :duration="1500" /></span>
                        </h2>
                        </div>
                    </div>
                </div>

            <div class="row">
                <div class="column">
                    <div class="card">
                        <h4>Laatste transacties</h4>
                        <div v-if="(transactions || []).length === 0"><small>Geen transacties gevonden voor de geselecteerde periode.</small></div>
                        <table v-else class="table is-fullwidth">
                            <thead>
                                <tr>
                                    <th>Datum</th>
                                    <th>Factuur</th>
                                    <th>Klant</th>
                                    <th class="text-right">Bedrag</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="t in transactions" :key="t.id">
                                    <td>{{ moment(t.date).format('DD MMM') }}</td>
                                    <td><router-link v-if="t.invoice" :to="{ name: 'InvoicesRecord', params: { type: 'recent', id: t.invoice.id } }">#{{ hideSensitiveData ? '****' : t.invoice.number }}</router-link><span v-else>-</span></td>
                                    <td>{{ hideSensitiveData ? '****' : (t.customer ? t.customer.name : '-') }}</td>
                                    <td class="text-right" :class="t.in_out === 'in' ? 'text-success' : 'text-danger'">
                                        {{ t.in_out === 'in' ? '+' : '-' }} € {{ hideSensitiveData ? '****' : number_format(Math.abs(t.amount||0), 2) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                </div>
            </div>
        </div>

        <div class="column" v-if="(env == 'local' || env == 'test') && (user && user.role == 'pit')">
            <hr>
            <TestModule />
        </div>
    </div>
</template>

<script>
import TestModule from './TestModule'
import paramsMixin from '@/mixins/paramsMixin'
import AnimatedNumber from './components/AnimatedNumber.vue'

// CHARTS: https://apexcharts.com/vue-chart-demos/

export default {
    name: 'Dashboard',

    components: {
        TestModule,
        AnimatedNumber
    },

    mixins: [paramsMixin],

    data() {
        return {
            paymentsKey: 0,
            paymentsAggKey: 0,
            updateProductGraphKey: 0,
            updateBoxKey: 0,
            invoicesKey: 0,
            loading: false,

            noInvoices: false,
            noBoxes: false,
            noProducts: false,

            searchParams: typeof(this.$store.state.searchQueries['Dashboard']) != 'undefined' ? this.$store.state.searchQueries['Dashboard'] : null,

            activeContracts: 0,
            emailsSend: 0,
            customerCount: 0,
            onlineRentals: 0,

            paymentTab: 1,
            paymentType: 'increasing',
            payments: {
                series: [{
                    name: 'Gefactureerd',
                    data: []
                }, {
                    name: 'Betaald',
                    data: []
                }, {
                    name: 'Mislukt',
                    data: []
                },
                {
                    name: 'Gecrediteerd',
                    data: []
                }],
                chartOptions: {
                    chart: {
                        height: 350,
                        type: 'area',
                        zoom: {
                            autoScaleYaxis: true
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    colors: ['#5963d7', '#1ea94f', '#ffdd57', '#cc091e'],
                    yaxis: {
                        show: this.hidePrices,
                    },
                    xaxis: {
                        type: 'date',
                        tickAmount: 10,
                        categories: [],
                        labels: {
                            rotate: -30,
                            rotateAlways: true,
                            formatter: function(val, timestamp) {
                                return moment(val, 'YYYY-MM-DD').format('DD MMM')
                            }
                        }
                    },
                    tooltip: {
                        x: {
                            format: 'dd/MM/yy'
                        },
                    },
                }
            },

            // Aggregated series with YoY (we will populate series dynamically)
            paymentsAgg: {
                series: [],
                chartOptions: {
                    chart: { height: 250, type: 'area', toolbar: { show: false } },
                    dataLabels: { enabled: false },
                    stroke: { curve: 'smooth', width: 3 },
                    markers: { size: 3, hover: { sizeOffset: 2 } },
                    colors: ['#1ea94f', '#7a7a7a', '#5963d7', '#cc091e', '#ffdd57'],
                    yaxis: [{ show: this.hidePrices }],
                    xaxis: { type: 'datetime', tickAmount: 10, categories: [], labels: { rotate: -30, rotateAlways: true, formatter: function(val){ return moment(val).format('DD MMM') } } },
                    tooltip: { x: { format: 'dd/MM/yy' } },
                    legend: { position: 'top' },
                    annotations: { xaxis: [] }
                }
            },

            escalationsKey: 0,
            escalations: {
                series: [0, 0],
                chartOptions: {
                    chart: { type: 'donut', animations: { enabled: false }, height: 280, width: '100%' },
                    labels: ['Open', 'Betaald'],
                    colors: ['#FF6200', '#1ea94f'],
                    legend: { position: 'bottom' },
                    dataLabels: { enabled: true, formatter: (val, opts) => {
                        const totals = opts.w.globals.seriesTotals.reduce((a, b) => a + b, 0) || 1
                        const valAbs = opts.w.globals.series[opts.seriesIndex]
                        const pct = Math.round((valAbs / totals) * 100)
                        return pct + '%'
                    } },
                    plotOptions: { pie: { donut: { size: '65%' } } },
                    responsive: [{
                        breakpoint: 9999,
                        options: {
                            chart: { height: 395 }
                        }
                    }, {
                        breakpoint: 1800,
                        options: {
                            chart: { height: 420 }
                        }
                    }, {
                        breakpoint: 1600,
                        options: {
                            chart: { height: 300 }
                        }
                    }, {
                        breakpoint: 1420,
                        options: {
                            chart: { height: 250 }
                        }
                    }]
                }
            },
            escalationsTotals: { open: 0, paid: 0 },
            boxUtilizationKey: 0,
            boxUtilization: {
                series: [0, 0],
                chartOptions: {
                    chart: { type: 'donut', animations: { enabled: false }, height: 280, width: '100%' },
                    labels: ['Verhuurd', 'Beschikbaar'],
                    colors: ['#cc091e', '#1ea94f'], // Red for rented, Green for available
                    legend: { position: 'bottom' },
                    dataLabels: { enabled: true, formatter: (val, opts) => {
                        const totals = opts.w.globals.seriesTotals.reduce((a, b) => a + b, 0) || 1
                        const valAbs = opts.w.globals.series[opts.seriesIndex]
                        const pct = Math.round((valAbs / totals) * 100)
                        return pct + '%'
                    } },
                    plotOptions: { pie: { donut: { size: '65%' } } },
                    responsive: [{
                        breakpoint: 9999,
                        options: {
                            chart: { height: 395 }
                        }
                    }, {
                        breakpoint: 1800,
                        options: {
                            chart: { height: 420 }
                        }
                    }, {
                        breakpoint: 1600,
                        options: {
                            chart: { height: 300 }
                        }
                    }, {
                        breakpoint: 1420,
                        options: {
                            chart: { height: 250 }
                        }
                    }]
                }
            },

            kpis: {},
            transactions: [],
            paymentsAggTotals: { invoiced: 0, paid: 0, credited: 0 },
            chartView: 'boxes', // Track which chart to show - default to boxes
            // Optional series toggles
            showInvoiced: false,
            showCredited: false,
            showFailed: false,
            paymentsAggCache: { inv: [], paid: [], cred: [], fail: [], paidLy: [], cats: [] }
        }
    },

    computed: {
        env() {
            return this.$store.state.env
        },

        user() {
            return this.$store.state.user
        },

        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },

        greeting() {
            return moment().format('HH') < 12 ? 'Goedemorgen' : moment().format('HH') < 18 ? 'Goedemiddag' : 'Goedenavond'
        },

        showEscalation(){
            const user = this.user || {}
            const orgSettings = user.organisation_settings || {}
            return (user.role === 'pit') || (!!orgSettings.escalation && parseInt(orgSettings.escalation) === 1)
        },

        hasRangeSelected(){
            return !_.isNull(this.dateRange)
        },

                                showEscalationCard(){
            // Check if we have escalation data in the escalationsTotals
            const totals = this.escalationsTotals || {}
            const hasData = (totals.open > 0 || totals.paid > 0)
            return hasData && this.showEscalation
        },

        showBoxUtilizationCard(){
            // Show when escalations are hidden and we have box data
            if (this.showEscalationCard) return false
            return (this.kpis.boxes_rented_count || 0) > 0 || (this.kpis.total_boxes_count || 0) > 0
        },

        hasBoxData(){
            return (this.kpis.boxes_rented_count || 0) > 0 || (this.kpis.total_boxes_count || 0) > 0
        },

        boxUtilizationPercentage(){
            if (!this.kpis.total_boxes_count || this.kpis.total_boxes_count === 0) return 0
            return Math.round((this.kpis.boxes_rented_count || 0) / this.kpis.total_boxes_count * 100)
        },

        hasEscalationData(){
            return this.showEscalationCard
        },

        // KPI computed helpers to avoid NaN and ensure always-on arrows with default trailing-month range
        prevCustomers(){ return Number(this.kpis.new_customers_prev || 0) },
        deltaCustomers(){ return Number((this.kpis.new_customers || 0) - (this.kpis.new_customers_prev || 0)) },
        // Percent change vs previous period (not of total)
        percCustomers(){ return this.prevCustomers > 0 ? (((this.kpis.new_customers || 0) - this.prevCustomers) / this.prevCustomers * 100).toFixed(0) : 0 },
        // Share of total
        shareCustomers(){ return (this.kpis.total_customers || 0) > 0 ? ((this.kpis.new_customers || 0) / (this.kpis.total_customers || 1) * 100).toFixed(0) : 0 },

        prevOnline(){ return Number(this.kpis.online_rentals_prev || 0) },
        deltaOnline(){ return Number((this.kpis.online_rentals || 0) - (this.kpis.online_rentals_prev || 0)) },
        percOnline(){ return this.prevOnline > 0 ? (((this.kpis.online_rentals || 0) - this.prevOnline) / this.prevOnline * 100).toFixed(0) : 0 },
        shareOnline(){ return (this.kpis.online_rentals_total || 0) > 0 ? ((this.kpis.online_rentals || 0) / (this.kpis.online_rentals_total || 1) * 100).toFixed(0) : 0 },

        prevContracts(){ return Number(this.kpis.contracts_started_prev || 0) },
        deltaContracts(){ return Number((this.kpis.contracts_started || 0) - (this.kpis.contracts_started_prev || 0)) },
        percContracts(){ return this.prevContracts > 0 ? (((this.kpis.contracts_started || 0) - this.prevContracts) / this.prevContracts * 100).toFixed(0) : 0 },
        shareContracts(){ return (this.kpis.contracts_total_active || 0) > 0 ? ((this.kpis.contracts_started || 0) / (this.kpis.contracts_total_active || 1) * 100).toFixed(0) : 0 }
    },

    created(){
        this.loading = true

        this.getSearchParams().then(() => {
            this.loadAsyncData()
        })
    },

    mounted() {
        this.checkRedirect()
    },

    methods: {
        loadAsyncData(){
            // Set filter params & admin params
            const params = this.setParams(this.searchParams, 'Dashboard')

            this.loading = true

            axios.get(`/api/dashboard/aggregated${params ? '?' + params : ''}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                // Stop loading as soon as we have the essential data for charts
                this.loading = false

                // Process essential data first
                this.setAggregatedPayments(response.data.payments)
                this.setEscalations(response.data.escalations)
                this.kpis = response.data.kpis || {}

                // Process remaining data
                this.transactions = response.data.transactions || []
                this.setBoxUtilization()

                this.$store.dispatch('setSearchQuery', {type: 'Dashboard', query: params})
            }).catch((error) => {
                console.error('[❌] Error while fetching the dashboard:', error)
                this.loading = false
            }).then(() => {
                this.searchParams = null
            })
        },

        setPayments(data){
            // Reset
            this.payments.chartOptions.xaxis.categories = []
            this.payments.series[0].data = []
            this.payments.series[1].data = []
            this.payments.series[2].data = []
            this.payments.series[3].data = []

            if (this.paymentType === 'day') {
                _.each(data, (payments, date) => {
                    this.payments.chartOptions.xaxis.categories.push(moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD'))

                    this.payments.series[0].data.push(this.toFixedNmbr(payments.invoiced))
                    this.payments.series[1].data.push(this.toFixedNmbr(payments.paid))
                    this.payments.series[2].data.push(this.toFixedNmbr(payments.failed))
                    this.payments.series[3].data.push(this.toFixedNmbr(payments.credited))
                })
            } else if (this.paymentType == 'increasing') {
                let totalInvoiced = 0
                let totalPaid = 0
                let totalFailed = 0
                let totalCredited = 0

                _.each(data, (payments, date) => {
                    this.payments.chartOptions.xaxis.categories.push(moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD'))

                    totalInvoiced += payments.invoiced
                    totalPaid += payments.paid
                    totalFailed += payments.failed
                    totalCredited += payments.credited

                    this.payments.series[0].data.push(this.toFixedNmbr(totalInvoiced))
                    this.payments.series[1].data.push(this.toFixedNmbr(totalPaid))
                    this.payments.series[2].data.push(this.toFixedNmbr(totalFailed))
                    this.payments.series[3].data.push(this.toFixedNmbr(totalCredited))
                })
            }

            this.$set(this, 'paymentsKey', this.paymentsKey + 1)
        },

        setAggregatedPayments(payload){
            // Reset series
            this.paymentsAgg.series = []
            this.paymentsAgg.chartOptions.xaxis.categories = []

            // Extract series data
            const invCurr = (payload && payload.current && Array.isArray(payload.current.invoiced)) ? payload.current.invoiced : []
            const paidCurr = (payload && payload.current && Array.isArray(payload.current.paid)) ? payload.current.paid : []
            const credCurr = (payload && payload.current && Array.isArray(payload.current.credited)) ? payload.current.credited : []
            const failCurr = (payload && payload.current && Array.isArray(payload.current.failed)) ? payload.current.failed : []
            const paidLy = (payload && payload.lastYear && Array.isArray(payload.lastYear.paid)) ? payload.lastYear.paid : []

                        // Debug logging removed to reduce console output

            // Convert to cumulative if needed
            const makeCumulative = (arr) => {
                let sum = 0;
                return arr.map(v => {
                    sum += parseFloat(v || 0);
                    return parseFloat(sum.toFixed(2));
                })
            }

            const finalInvCurr = this.paymentType === 'increasing' ? makeCumulative(invCurr) : invCurr
            const finalPaidCurr = this.paymentType === 'increasing' ? makeCumulative(paidCurr) : paidCurr
            const finalCredCurr = this.paymentType === 'increasing' ? makeCumulative(credCurr) : credCurr
            const finalFailCurr = this.paymentType === 'increasing' ? makeCumulative(failCurr) : failCurr
            const finalPaidLy = this.paymentType === 'increasing' ? makeCumulative(paidLy) : paidLy

            // Use categories from backend (should be aligned)
            const cats = (payload && Array.isArray(payload.categories)) ? payload.categories : []
            this.paymentsAgg.chartOptions.xaxis.categories = cats

            // Build full series arrays (null-padded to match categories length)
            const invCurrFull = Array(cats.length).fill(null)
            const paidCurrFull = Array(cats.length).fill(null)
            const credCurrFull = Array(cats.length).fill(null)
            const failCurrFull = Array(cats.length).fill(null)
            const lyPaidFull = Array(cats.length).fill(null)

            // Fill current month data
            finalInvCurr.forEach((v, i) => { if (i < invCurrFull.length) invCurrFull[i] = v })
            finalPaidCurr.forEach((v, i) => { if (i < paidCurrFull.length) paidCurrFull[i] = v })
            finalCredCurr.forEach((v, i) => { if (i < credCurrFull.length) credCurrFull[i] = v })
            finalFailCurr.forEach((v, i) => { if (i < failCurrFull.length) failCurrFull[i] = v })

            // Fill last year data (aligned to current month start)
            const idxCurrMonthStart = cats.findIndex(d => moment(d, 'YYYY-MM-DD').date() === 1)
            if (idxCurrMonthStart >= 0) {
                finalPaidLy.forEach((v, i) => {
                    const idx = idxCurrMonthStart + i
                    if (idx < lyPaidFull.length) {
                        lyPaidFull[idx] = v
                    }
                })
            }

            // Replace x-axis with aligned categories
            this.paymentsAgg.chartOptions = Object.assign({}, this.paymentsAgg.chartOptions, {
                xaxis: Object.assign({}, this.paymentsAgg.chartOptions.xaxis, { categories: cats }),
                annotations: Object.assign({}, this.paymentsAgg.chartOptions.annotations, {
                    xaxis: this.hasRangeSelected ? [] : [
                        {
                            x: moment().startOf('day').toDate().getTime(),
                            borderColor: '#999',
                            label: { text: 'Vandaag', style: { background: '#fff', color: '#333' } }
                        },
                        {
                            x: moment().endOf('month').startOf('day').toDate().getTime(),
                            borderColor: '#bbb',
                            label: { text: 'Einde maand', style: { background: '#fff', color: '#333' } }
                        }
                    ]
                })
            })

            // Build invoiced line including future invoices
            const todayStr = moment().format('YYYY-MM-DD')
            const todayIdx = cats.indexOf(todayStr)
            let invToday = finalInvCurr.slice(0, cats.length)

            // Keep all invoiced values, including future ones
            // This ensures we show future invoices like October 1st

            // Cache raw series and render based on toggles
            this.paymentsAggCache = {
                inv: invCurrFull,
                invToday: invToday,
                paid: paidCurrFull,
                cred: credCurrFull,
                fail: failCurrFull,
                paidLy: lyPaidFull,
                cats: cats
            }

            // Debug logging for credit data
            // Debug logging removed

            // Calculate totals based on selected range or current month
            let sumInv = 0
            let sumPaid = 0
            let sumCredited = 0

            if (this.hasRangeSelected && this.dateRange && this.dateRange.length === 2) {
                // Use selected date range totals
                const fromDate = moment(this.dateRange[0]).format('YYYY-MM-DD')
                const toDate = moment(this.dateRange[1]).format('YYYY-MM-DD')

                // Calculate totals for date range

                cats.forEach((d, i) => {
                    if (d >= fromDate && d <= toDate) {
                        // For cumulative data, we want the last value in the range, not the sum
                        if (this.paymentType === 'increasing') {
                            sumInv = parseFloat((finalInvCurr[i]) || 0)
                            sumPaid = parseFloat((finalPaidCurr[i]) || 0)
                            sumCredited = parseFloat((finalCredCurr[i]) || 0)
                        } else {
                            sumInv += parseFloat((finalInvCurr[i]) || 0)
                            sumPaid += parseFloat((finalPaidCurr[i]) || 0)
                            sumCredited += parseFloat((finalCredCurr[i]) || 0)
                        }
                    }
                })


            } else {
                // Use current month totals (fallback)
                const monthStart = moment().startOf('month')
                const monthEnd = moment().endOf('month')

                // Calculate totals for current month

                cats.forEach((d, i) => {
                    const m = moment(d, 'YYYY-MM-DD')
                    if (m.isSameOrAfter(monthStart) && m.isSameOrBefore(monthEnd)) {
                        if (this.paymentType === 'increasing') {
                            sumInv = parseFloat((finalInvCurr[i]) || 0)
                            sumPaid = parseFloat((finalPaidCurr[i]) || 0)
                            sumCredited = parseFloat((finalCredCurr[i]) || 0)
                        } else {
                            sumInv += parseFloat((finalInvCurr[i]) || 0)
                            sumPaid += parseFloat((finalPaidCurr[i]) || 0)
                            sumCredited += parseFloat((finalCredCurr[i]) || 0)
                        }
                    }
                })


            }

            // Always use our calculated totals, not backend totals
            this.paymentsAggTotals.invoiced = Number(sumInv.toFixed(2))
            this.paymentsAggTotals.paid = Number(sumPaid.toFixed(2))
            this.paymentsAggTotals.credited = Number(sumCredited.toFixed(2))



            // Now render the series after calculating totals
            this.renderPaymentsSeries()
            ++this.paymentsAggKey
        },

        renderPaymentsSeries(){
            const s = []
            // Green: current paid
            s.push({ name: 'Betaald', type: 'area', data: this.paymentsAggCache.paid })
            // Blue: invoiced till today
            if (this.paymentsAggCache.invToday && this.paymentsAggCache.invToday.some(v => v)) {
                s.push({ name: 'Gefactureerd', type: 'line', data: this.paymentsAggCache.invToday })
            }
            // Red: current credited - always show if there's any data
            if (this.paymentsAggCache.cred && this.paymentsAggCache.cred.length > 0) {
                s.push({ name: 'Gecrediteerd', type: 'line', data: this.paymentsAggCache.cred })
            }
            // Solid gray: last year this month
            s.push({ name: 'Betaald (Vorig jaar)', type: 'line', data: this.paymentsAggCache.paidLy })

            this.paymentsAgg.series = s

            // Colors per series (green current paid, blue invoiced till today, red for credited, gray for last year)
            const colors = s.map(ser => ser.name === 'Betaald' ? '#1ea94f' : (ser.name === 'Gefactureerd' ? '#5963d7' : (ser.name === 'Gecrediteerd' ? '#cc091e' : '#7a7a7a')))
            this.paymentsAgg.chartOptions = Object.assign({}, this.paymentsAgg.chartOptions, {
                colors
            })
            this.$nextTick(() => { this.paymentsAggKey += 1 })
        },

        setEscalations(payload){
            const openSeries = (payload && payload.current && Array.isArray(payload.current.open)) ? payload.current.open : []
            const paidSeries = (payload && payload.current && Array.isArray(payload.current.paid)) ? payload.current.paid : []
            const totalOpen = openSeries.length ? Number(openSeries[openSeries.length - 1] || 0) : 0
            const totalPaid = paidSeries.length ? Number(paidSeries[paidSeries.length - 1] || 0) : 0
            // Apex donut expects a plain numeric array
            const nextSeries = [Number(totalOpen), Number(totalPaid)]
            this.$nextTick(() => {
                this.escalations.series = nextSeries
                this.escalationsKey += 1
                this.escalationsTotals.open = payload?.totals?.open || totalOpen
                this.escalationsTotals.paid = payload?.totals?.paid || totalPaid
            })
        },

        setBoxUtilization(){
            const rentedCount = Number(this.kpis.boxes_rented_count || 0)
            const totalCount = Number(this.kpis.total_boxes_count || 0)
            const availableCount = Math.max(0, totalCount - rentedCount)
            const series = [rentedCount, availableCount]

            // Ensure the chart maintains the same responsive sizing
            this.$nextTick(() => {
                this.boxUtilization.series = series
                this.boxUtilizationKey += 1

                // Force chart resize to ensure consistent sizing
                if (this.$refs.boxUtilizationChart) {
                    this.$refs.boxUtilizationChart.updateOptions({
                        chart: { height: this.boxUtilization.chartOptions.chart.height }
                    })
                }
            })
        },

        toFixedNmbr(val, decimals = 2){
            val = parseFloat(val)
            return val.toFixed(decimals)
        },

        number_format(val, decimals = 2) {
            val = parseFloat(val)
            return val.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
        },

        checkRedirect(){
            if(this.user && _.has(this.user, 'settings.loginredirect') && !this.$store.state.auth_redirected) {
                switch(this.user.settings.loginredirect){
                    case 1:
                        if(this.user.deurwaarder) {
                            this.$router.push({name: 'InvoicesOverview', params: {type: 'geescaleerd'}})
                            return;
                        }

                        // Redirect to invoices if you cannot.
                        if(_.has(this.user.organisation_settings, 'dashboard_onlyadmin') && this.user.organisation_settings.dashboard_onlyadmin == 1 && (this.user.role != 'pit' && !this.user.is_admin)){
                            this.$router.push({name: 'InvoicesOverview', params: {type: 'recent'}})
                        } else {
                            this.getSearchParams().then(() => {
                                this.loadAsyncData()
                            })
                        }
                    break;
                    case 2:
                        // Boxen lijstweergave
                        this.$router.push({name: 'BoxesOverview'})
                    break;
                    case 3:
                        // Boxen plattegrond
                        this.$router.push({name: 'BoxesOverview', query: {floormap: '1'}})
                    break;
                    case 4:
                        // Contracten
                        this.$router.push({name: 'ContractsOverview'})
                    break;
                    case 5:
                        // Facturen
                        this.$router.push({name: 'InvoicesOverview'})
                    break;
                    case 6:
                        // Klanten
                        this.$router.push({name: 'CustomersOverview'})
                    break;
                }

                this.$store.dispatch('setAuthRedirected', true)
                return;
            } else if(_.has(this.user.organisation_settings, 'dashboard_onlyadmin') && this.user.organisation_settings.dashboard_onlyadmin == 1 && (this.user.role != 'pit' && !this.user.is_admin)){
                if(this.user.deurwaarder) {
                    this.$router.push({name: 'InvoicesOverview', params: {type: 'geescaleerd'}})
                    return;
                }

                this.$router.push({name: 'InvoicesOverview', params: {type: 'recent'}})
            } else {
                if(this.user.deurwaarder) {
                    this.$router.push({name: 'InvoicesOverview', params: {type: 'geescaleerd'}})
                    return;
                }

                this.$router.push({name: 'Dashboard'})
            }
        },

        formatNumber(number){
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },

        paymentTabChanged (tab) {
            this.paymentType = tab === 0 ? 'day' : 'increasing'
            // this.setPayments(this.paymentsData)
            this.loadAsyncData()
        }
    },

    watch: {
        paymentTab(tab){
            this.paymentType = tab === 0 ? 'day' : 'increasing'
            // Re-render aggregate series with new mode
            this.loadAsyncData()
        },
        showInvoiced(){ this.renderPaymentsSeries() },
        showCredited(){ this.renderPaymentsSeries() },
        showFailed(){ this.renderPaymentsSeries() },
        hideSensitiveData(newVal){
            this.payments.chartOptions.yaxis.show = !newVal
            ++this.paymentsKey
        },

        user(){
            this.checkRedirect()
        },

        '$route.query.org'(newOrg, oldOrg) {
            if (!newOrg) return

            if (newOrg !== oldOrg) {
                this.$store.dispatch('setAuthRedirected', false)
                this.checkRedirect()
            }
        },

                chartView(newView) {
            // Force re-render of the appropriate chart
            this.$nextTick(() => {
                if (newView === 'escalations') {
                    // Make sure escalation chart data is properly set
                    const open = this.escalationsTotals.open || 0;
                    const paid = this.escalationsTotals.paid || 0;
                    this.escalations.series = [Number(open), Number(paid)];
                    this.escalationsKey += 1;
                } else {
                    // Re-render box utilization chart
                    this.setBoxUtilization();
                }
            });
        }
    }
}
</script>

<style scoped>
.dashboard .card {
    height: auto;
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
}

.dashboard .card:last-child {
    margin-bottom: 0;
}

.dashboard .card h4 {
    margin-bottom: 1rem;
    flex-shrink: 0;
}

.dashboard .card .row:last-child {
    margin-top: auto;
}

.dashboard .column.large-5 .card {
    margin-bottom: 1rem;
}

.dashboard .column.large-5 .card:last-child {
    margin-bottom: 0;
}

/* Ensure charts maintain aspect ratio */
.dashboard .card .apexcharts-canvas {
    margin: 0 auto;
    max-width: 100%;
    max-height: 280px;
}

/* Fix for donut chart distortion */
.dashboard .card .apexcharts-donut {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 100%;
    max-height: 280px;
}

/* Chart placeholder styling */
.dashboard .chart-placeholder {
    height: 280px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
    border-radius: 6px;
    border: 2px dashed #dee2e6;
}

.dashboard .placeholder-text {
    color: #6c757d;
    font-size: 1rem;
    font-weight: 500;
}

/* Consistent spacing for right column */
.dashboard .column.large-5 {
    display: flex;
    flex-direction: column;
}

.dashboard .column.large-5 .card {
    flex: 0 0 auto; /* Don't stretch cards */
    margin-bottom: 1rem;
}

.dashboard .column.large-5 .card:last-child {
    margin-bottom: 0;
}

/* Actieve contracten card should be compact */
.dashboard .column.large-5 .compact-card {
    min-height: auto;
    flex: 0 0 auto;
    padding: 1rem;
}

/* Ensure main graph area is consistent */
.dashboard .column.large-7 .card {
    min-height: 350px; /* Account for main graph height + padding */
}

/* KPI Cards Grid Layout */
.dashboard .kpi-card {
    height: 100%;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 1.5rem;
    text-align: left;
    box-sizing: border-box;
}

.dashboard .kpi-card h6 {
    margin-bottom: 0;
    color: #666;
    font-size: 0.9rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    flex-shrink: 0;
}

.dashboard .kpi-card h2 {
    margin: 0;
    line-height: 1.2;
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: flex-start;
}

.dashboard .kpi-card h2 strong {
    font-size: 2.5rem;
    font-weight: 700;
    color: #333;
    display: inline;
    margin-right: 0.5rem;
}

.dashboard .kpi-card h2 small {
    font-size: 1rem;
    color: #888;
    font-weight: 400;
    display: inline;
}



/* Ensure grid columns have equal heights */
.dashboard .row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -0.75rem;
    margin-right: -0.75rem;
}

.dashboard .row .column {
    display: flex;
    flex-direction: column;
    padding: 0 0.75rem;
    margin-bottom: 1rem;
}

.dashboard .row .column .kpi-card {
    flex: 1;
    margin-bottom: 0;
}

/* Responsive grid adjustments */
@media (max-width: 1200px) {
    .dashboard .kpi-card {
        min-height: 140px;
    }

    .dashboard .kpi-card h2 strong {
        font-size: 2.2rem;
    }
}

@media (max-width: 678px) {
    .dashboard .kpi-card {
        min-height: 120px;
    }

    .dashboard .kpi-card h2 strong {
        font-size: 2rem;
    }

    .dashboard .kpi-card h6 {
        font-size: 0.8rem;
    }
}

/* Radio button styling for chart toggle */
.dashboard .field .control .radio {
    margin-right: 1rem;
    font-size: 0.9rem;
    color: #666;
}

.dashboard .field .control .radio:last-child {
    margin-right: 0;
}

.dashboard .field .control .radio input[type="radio"] {
    margin-right: 0.5rem;
}

.dashboard .field .control .radio input[type="radio"]:checked + span {
    color: #3273dc;
    font-weight: 600;
}

@media (max-width: 1200px) {
    .dashboard .card {
        min-height: auto;
    }

    .dashboard .column.large-5 .card {
        min-height: 300px;
    }

}

@media (max-width: 678px) {
    .dashboard .column.large-5 .card {
        min-height: 280px;
    }

    .dashboard .column.large-7 .card {
        min-height: 300px;
    }
}
</style>
